import { Fund } from "@core/models/fund.model";
import { Product } from "@core/models/product.model";

export class ProductHelper {
  static getProductFunds(product: Product | undefined): Array<Fund> {
    return product?.funds ?? [];
  }
}
